import { apiCall } from 'app/shared/lib/essette-api';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { autoinject } from 'aurelia-framework';
import * as CM from 'app/cm/models/essette-api';
import { CaseService } from 'app/cm/services/case-service';
import { Toaster } from 'app/shared/lib/toaster';

@autoinject()
export class SaveAcuityCustomElement extends ComponentBase implements IForm {
    ////****************** Fields and Properties ************************************////
    protected isValid: boolean = false;

    public acuity?: CM.Acuity;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const response = await this.saveAcuity();
        this.reset();
        return response;

    }

    ////****************** Functions ***********************************************////

    public reset() {
        this.acuity = {};
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    public async saveAcuity(): Promise<boolean> {
        if(!this.acuity) return false;
        let isSuccessful = false;

        try {
            this.state.beginSave();
            const response = await this.service.saveAcuity(this.acuity);
            isSuccessful = response.isSuccessful;

        } catch(error) {

            throw error;
        } finally {
            this.toaster.standard.saved('cm:acuity.$', isSuccessful);
            this.state.endSave();
            return true;
        }

    }
}
